// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.table-widget .edit-virtual-scroll {
  width: 100%;
}
.table-widget .signal-name {
  flex-grow: 2;
}
.table-widget .drag-cursor {
  cursor: pointer;
  padding: 0rem 0rem;
}

.drag-list {
  padding: 0.5rem 0.5rem;
  max-width: 100%;
  min-width: 100%;
  min-height: 1rem;
  display: block;
  background: var(--widget-background-color);
  border-radius: 4px;
  overflow: hidden;
}

.table-row {
  padding: 0.5rem 0.5rem;
  border-bottom: solid 1px var(--widget-border-color);
  color: var(--widget-foreground-color);
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
  background: var(--widget-background-color);
}

.drag-box-edit {
  padding: 0rem 0rem;
  border-bottom: solid 1px var(--widget-border-color);
  color: var(--widget-foreground-color);
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
  background: var(--widget-background-color);
}

.cdk-drag-preview {
  box-sizing: border-box;
  border-radius: 4px;
  box-shadow: 0 5px 5px -3px rgba(0, 0, 0, 0.2), 0 8px 10px 1px rgba(0, 0, 0, 0.14), 0 3px 14px 2px rgba(0, 0, 0, 0.12);
}

.cdk-drag-placeholder {
  opacity: 0;
}

.cdk-drag-animating {
  transition: transform 250ms cubic-bezier(0, 0, 0.2, 1);
}

.example-box:last-child {
  border: none;
}

.drag-list.cdk-drop-list-dragging .drag-box:not(.cdk-drag-placeholder) {
  transition: transform 250ms cubic-bezier(0, 0, 0.2, 1);
}

.flex-top-row {
  display: flex;
  flex-direction: row;
}
.flex-top-row .edit-icon {
  background-color: inherit;
  border: none;
}
.flex-top-row .view-title {
  flex-grow: 1;
}`, "",{"version":3,"sources":["webpack://./src/app/widgets/list-widget/list-widget.component.scss"],"names":[],"mappings":"AACI;EACI,WAAA;AAAR;AAGI;EACI,YAAA;AADR;AAII;EACI,eAAA;EACA,kBAAA;AAFR;;AAOA;EACI,sBAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,0CAAA;EACA,kBAAA;EACA,gBAAA;AAJJ;;AASA;EACI,sBAAA;EACA,mDAAA;EACA,qCAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,8BAAA;EACA,sBAAA;EACA,0CAAA;AANJ;;AASA;EACI,kBAAA;EACA,mDAAA;EACA,qCAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,8BAAA;EACA,sBAAA;EACA,0CAAA;AANJ;;AASA;EACI,sBAAA;EACA,kBAAA;EACA,qHAAA;AANJ;;AAWA;EACI,UAAA;AARJ;;AAWA;EACI,sDAAA;AARJ;;AAWA;EACI,YAAA;AARJ;;AAWA;EACI,sDAAA;AARJ;;AAWA;EACI,aAAA;EACA,mBAAA;AARJ;AAUI;EACI,yBAAA;EACA,YAAA;AARR;AAWI;EACI,YAAA;AATR","sourcesContent":[".table-widget {\n    .edit-virtual-scroll {\n        width: 100%;\n    }\n\n    .signal-name {\n        flex-grow: 2;\n    }\n\n    .drag-cursor {\n        cursor: pointer;\n        padding: 0rem 0rem;\n    }\n\n}\n\n.drag-list {\n    padding: 0.5rem 0.5rem;\n    max-width: 100%;\n    min-width: 100%;\n    min-height: 1rem;\n    display: block;\n    background: var(--widget-background-color);\n    border-radius: 4px;\n    overflow: hidden;\n\n}\n\n\n.table-row {\n    padding: 0.5rem 0.5rem;\n    border-bottom: solid 1px var(--widget-border-color);\n    color: var(--widget-foreground-color);\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: space-between;\n    box-sizing: border-box;\n    background: var(--widget-background-color);\n}\n\n.drag-box-edit {\n    padding: 0.0rem 0.0rem;\n    border-bottom: solid 1px var(--widget-border-color);\n    color: var(--widget-foreground-color);\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: space-between;\n    box-sizing: border-box;\n    background: var(--widget-background-color);\n}\n\n.cdk-drag-preview {\n    box-sizing: border-box;\n    border-radius: 4px;\n    box-shadow: 0 5px 5px -3px rgba(0, 0, 0, 0.2),\n        0 8px 10px 1px rgba(0, 0, 0, 0.14),\n        0 3px 14px 2px rgba(0, 0, 0, 0.12);\n}\n\n.cdk-drag-placeholder {\n    opacity: 0;\n}\n\n.cdk-drag-animating {\n    transition: transform 250ms cubic-bezier(0, 0, 0.2, 1);\n}\n\n.example-box:last-child {\n    border: none;\n}\n\n.drag-list.cdk-drop-list-dragging .drag-box:not(.cdk-drag-placeholder) {\n    transition: transform 250ms cubic-bezier(0, 0, 0.2, 1);\n}\n\n.flex-top-row {\n    display: flex;\n    flex-direction: row;\n\n    .edit-icon {\n        background-color: inherit;\n        border: none;\n    }\n\n    .view-title {\n        flex-grow: 1;\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
